import axios from "axios"
import moment from "moment"
import React, { Component } from "react"
import { Button, FormControl, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import AxiosConfig from "../../../../utilities/AxiosConfig"
import reggie from "../../../../utilities/Reggie"
import snackBar from "../../../../utilities/snackBar/SnackBar"
import BaseChecklistTypes from "../../Types/BaseChecklistTypes"
import baseChecklistBoiler from "./BaseCheclklistItemBoiler"
import "../BaseChecklistConfig.css"

interface Props {
    userId: number | string
}


interface State {
    checklists: Array<any>
    loading: Array<boolean>
    reference: {
        incidentStatus: Array<{ id: number, text: string }>,
        incidentTimelineTypes: Array<{ id: number, text: string }>,
        incidentTypes: Array<{ id: number, text: string }>
    }
    item: BaseChecklistTypes | null
    itemCopy: BaseChecklistTypes | null
    confirmDelete: boolean
    editing: boolean
    adding: boolean
    linkType: string
    eventType: string
    itemIndex: string
    confirmDiscard: boolean
}



class BaseChecklistConfig extends Component<Props, State> {

    checklistsTemp: any = []
    getIndex = 0
    state = {
        reference: { incidentStatus: [], incidentTimelineTypes: [], incidentTypes: [] },
        checklists: [[], [], []],
        loading: [true, true, true],
        item: null,
        itemCopy: null,
        confirmDelete: false,
        editing: false,
        adding: false,
        linkType: "DocumentLink",
        eventType: "",
        itemIndex: "-1",
        confirmDiscard: false
    }

    componentDidMount() {
        this.getReference()
    }

    setEventType = (type: string) => {
        this.setState({ eventType: type })
    }

    handleChange = (event: { target: { value: string | null } }) => {
        let input = event.target.value
        if (input === "") {
            input = null
        }
        if (input && this.state.linkType === "Phone") {
            input = this.formatter(input)
        }
        let item: any = this.state.item
        item[this.state.eventType] = input
        this.setState({ item: item })
    }

    formatter = (input: string) => {
        //@ts-ignore
        let formated = reggie[`format${this.state.linkType}`](input)
        if (formated) {
            return formated
        }
        return input
    }

    validator = (input: string) => {
        //@ts-ignore
        return reggie[`validate${this.state.linkType}`](input)
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (!keys[i].value) {
                state[keys[i].key] = !state[keys[i].key]
            } else {
                state[keys[i].key] = keys[i].value
            }
        }
        this.setState(state)
    }

    getReference = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/workComp/reference", AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ reference: res.data })
                this.getChecklists()
            }).catch(err => {
                //console.log(err)
            })
    }

    getChecklists = () => {
        this.getIndex++
        let loading = this.state.loading
        if (this.getIndex <= 3) {
            loading[this.getIndex] = true
            this.setState({ loading: loading })
            axios.get(process.env.REACT_APP_API_URL + `/api/workComp/getIncidentBaseChecklist/${this.getIndex}`, AxiosConfig.configValue("min"))
                .then((res) => {
                    // //console.log("incident:" ,res.data)
                    this.checklistsTemp.push(res.data)
                    this.getChecklists()
                })
                .catch(() => {
                    let loading = this.state.loading
                    loading[this.getIndex] = false
                    snackBar({ text: "Failed to fetch Incident checklists", type: "error", timeout: 4000 })
                })
        } else {
            this.setState({ checklists: this.checklistsTemp, loading: [false, false, false] })
        }
    }

    getChecklist = (index: number) => {
        axios.get(process.env.REACT_APP_API_URL + `/api/workComp/getIncidentBaseChecklist/${index}`, AxiosConfig.configValue("min"))
            .then((res) => {
                this.checklistsTemp[index - 1] = res.data
                let loading = this.state.loading
                loading[index - 1] = false
                this.setState({ checklists: this.checklistsTemp, loading: loading })
            })
            .catch(() => {
                this.setState({ loading: [false, false, false] })
                snackBar({ text: "Failed to fetch Incident checklists", type: "error", timeout: 4000 })
            })
    }

    updateBaseChecklist = (item: BaseChecklistTypes | any) => {
        this.setState({ editing: false, adding: false, confirmDelete: false })
        let index = item.WorkCompIncidentTypeId
        let loading = this.state.loading
        loading[index - 1] = true
        this.setState({ loading: loading })
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentBaseChecklistPost", item, AxiosConfig.configValue("min"))
            .then(() => {
                this.getChecklist(index)
            })
            .catch(() => {
                this.setState({ loading: [false, false, false] })
                snackBar({ text: "Failed to update Incident Base checklist", type: "error", timeout: 4000 })
            })
    }

    getChecklistType = (id: number) => {
        const reference: any = this.state.reference
        for (let i = 0; i < reference.incidentTypes.length; i++) {
            if (id === reference.incidentTypes[i].id) {
                return reference.incidentTypes[i].text
            }
        }
        return ""
    }

    addItem = (WorkCompIncidentTypeId: number) => {
        let item: BaseChecklistTypes = JSON.parse(JSON.stringify(baseChecklistBoiler))
        item.CreatedDateUtc = moment().format()
        item.CreatedBy = this.props.userId + ""
        item.WorkCompIncidentTypeId = WorkCompIncidentTypeId
        let itemCopy: BaseChecklistTypes = JSON.parse(JSON.stringify(item))
        this.manageState([{ key: "adding" }, { key: "item", value: item }, { key: "itemCopy", value: itemCopy }])
    }

    editItem = (item: BaseChecklistTypes) => {
        let itemCopy: BaseChecklistTypes = JSON.parse(JSON.stringify(item))
        this.manageState([{ key: "editing" }, { key: "item", value: item }, { key: "itemCopy", value: itemCopy }])
    }

    deleteItem = (item: BaseChecklistTypes) => {
        let temp = item
        temp.DeletedBy = this.props.userId + ""
        temp.DeletedDateUtc = moment().format()
        this.manageState([{ key: "confirmDelete" }, { key: "item", value: temp }])
    }

    isDirty = (item: BaseChecklistTypes, copy: BaseChecklistTypes) => {
        let a = JSON.stringify(item)
        let b = JSON.stringify(copy)
        if (a !== b) {
            return true
        }
        return false
    }

    shouldDiscard = (discardTypeKey: string) => {
        //@ts-ignore
        if (!this.isDirty(this.state.item, this.state.itemCopy)) {
            this.manageState([{ key: discardTypeKey }, { key: "item", value: null }])
        } else {
            this.manageState([{ key: "confirmDiscard" }])
        }
    }

    confirmDiscard = () => {
        this.setState({ adding: false, editing: false, confirmDiscard: false, item: null, itemCopy: null })
    }

    render() {

        let checklists = this.state.checklists
        let incidentTypes = this.state.reference.incidentTypes
        let loading = this.state.loading
        let linkType = this.state.linkType
        let state = this.state

        const toolTip = (text: string) => (
            <Tooltip id="uac-tool-tip">
                {text}
            </Tooltip>
        )


        return (
            <div className="BaseChecklistConfig">
                <div className="BaseChecklistConfigItems">
                    {incidentTypes.length > 0 && incidentTypes.map((item: any, referenceDex: number) =>
                        <div className="BaseChecklistConfigItem" key={referenceDex}>
                            <div className="BaseChecklistConfigItemHeader">
                                <p>{this.getChecklistType(referenceDex + 1)}</p>
                                {loading[referenceDex] && <Spinner id="base-checklist-config-item-header-spinner" animation="border" />}
                                <div className="AddChecklistitemBtn">
                                    <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip("Add a new checklist item")}>
                                        <span className="material-icons" id="" onClick={() => this.addItem(referenceDex + 1)}>add</span>
                                    </OverlayTrigger>
                                </div>
                            </div>

                            {checklists[referenceDex].length > 0 && checklists[referenceDex].map((subItem: BaseChecklistTypes, subItemIndex: number) =>
                                <div className="BaseChecklistConfigChecklistItem" key={subItemIndex}>
                                    <div className="BaseChecklistConfigChecklistItem">
                                        <div className="BaseChecklistConfigChecklistItemLeft">
                                            {subItem.ChecklistText && subItem.ChecklistText !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.ChecklistText)}>
                                                <p>{subItem.ChecklistText}</p>
                                            </OverlayTrigger>}
                                            {subItem.InfoText && subItem.InfoText !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.InfoText)}>
                                                <span className="material-icons">info</span>
                                            </OverlayTrigger>}
                                            {subItem.DocumentLink && subItem.DocumentLink !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.DocumentLink)}>
                                                <a href={subItem.DocumentLink || ""} target="_blank" rel="noreferrer"><span className="material-icons">description</span></a>
                                            </OverlayTrigger>}
                                            {subItem.Email && subItem.Email !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.Email)}>
                                                <a href={`mailto:${subItem.Email || ""}`} target="_blank" rel="noreferrer"><span className="material-icons">mail</span></a>
                                            </OverlayTrigger>}
                                            {subItem.Phone && subItem.Phone !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.Phone)}>
                                                <a href={`tel:${reggie.formatPhone(subItem.Phone || "")}`}><span className="material-icons">call</span></a>
                                            </OverlayTrigger>}
                                        </div>
                                        <div className="BaseChecklistConfigChecklistItemRight">
                                            <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip("Edit this checklist item")}>
                                                <span className="material-icons" id="base-checklist-config-checklist-item-right-edit" onClick={() => this.editItem(subItem)}>edit</span>
                                            </OverlayTrigger>
                                            <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip("Delete this checklist item")}>
                                                <span className="material-icons" id="base-checklist-config-checklist-item-right-delete" onClick={() => this.deleteItem(subItem)}>delete</span>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {(state.adding || state.editing) && !state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="ChecklistConfigModalAddBodyConfigHeader">
                            {this.state.adding && <p>Add a Checklist item</p>}
                            {this.state.editing && <p>Edit this Checklist item</p>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ChecklistConfigModalAddBodyConfigItems">
                            <div className="ChecklistConfigModalAddBodyR1">
                                <FormControl onFocus={() => this.setEventType("ChecklistText")}
                                    tabIndex={-1}
                                    placeholder={"Title"}
                                    onChange={this.handleChange}
                                    //@ts-ignore
                                    value={state.item.ChecklistText || ""}
                                />
                            </div>
                            <div className="ChecklistConfigModalAddBodyR2">
                                <FormControl
                                    onFocus={() => this.setEventType("InfoText")}
                                    tabIndex={-1}
                                    as="textarea" rows={4}
                                    placeholder={"Description (optional)"}
                                    onChange={this.handleChange}
                                    //@ts-ignore
                                    value={state.item.InfoText || ""}
                                />
                            </div>
                            <div className="ChecklistConfigModalAddBodyR3">
                                <div className="ChecklistConfigModalAddBodyR3LinkTypes">
                                    {linkType !== "DocumentLink" && <span className="material-icons" onClick={() => this.manageState([{ key: "linkType", value: "DocumentLink" }, { key: "eventType", value: "DocumentLink" }])}>description</span>}
                                    {linkType === "DocumentLink" && <span className="material-icons" id="add-checklist-item-active" onClick={() => this.manageState([{ key: "linkType", value: "DocumentLink" }, { key: "eventType", value: "DocumentLink" }])}>description</span>}
                                    {linkType !== "Phone" && <span className="material-icons" onClick={() => this.manageState([{ key: "linkType", value: "Phone" }, { key: "eventType", value: "Phone" }])}>call</span>}
                                    {linkType === "Phone" && <span className="material-icons" id="add-checklist-item-active" onClick={() => this.manageState([{ key: "linkType", value: "Phone" }, { key: "eventType", value: "Phone" }])}>call</span>}
                                    {linkType !== "Email" && <span className="material-icons" onClick={() => this.manageState([{ key: "linkType", value: "Email" }, { key: "eventType", value: "Email" }])}>email</span>}
                                    {linkType === "Email" && <span className="material-icons" id="add-checklist-item-active" onClick={() => this.manageState([{ key: "linkType", value: "Email" }, { key: "eventType", value: "Email" }])}>email</span>}
                                </div>
                                {linkType === "DocumentLink" && <div className="ChecklistConfigModalAddBodyR3FormWrapper">
                                    <FormControl
                                        onFocus={() => this.setEventType("DocumentLink")}
                                        tabIndex={-1}
                                        placeholder={reggie.deCamel(linkType)}
                                        onChange={this.handleChange}
                                        //@ts-ignore
                                        value={state.item.DocumentLink || ""}
                                    />
                                </div>}
                                {linkType === "Phone" && <div className="ChecklistConfigModalAddBodyR3FormWrapper">
                                    <FormControl
                                        onFocus={() => this.setEventType("Phone")}
                                        tabIndex={-1}
                                        placeholder={reggie.deCamel(linkType)}
                                        onChange={this.handleChange}
                                        //@ts-ignore
                                        value={this.formatter(state.item.Phone || "")}
                                    />
                                </div>}
                                {linkType === "Email" && <div className="ChecklistConfigModalAddBodyR3FormWrapper">
                                    <FormControl
                                        onFocus={() => this.setEventType("Email")}
                                        tabIndex={-1}
                                        placeholder={reggie.deCamel(linkType)}
                                        onChange={this.handleChange}
                                        //@ts-ignore
                                        value={state.item.Email || ""}
                                    />
                                </div>}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="BaseChecklistModalFooter">
                            {state.adding && <Button variant="secondary" onClick={() => this.shouldDiscard("adding")}>Back</Button>}
                            {state.editing && <Button variant="secondary" onClick={() => this.shouldDiscard("editing")}>Back</Button>}
                            {/*@ts-ignore*/}
                            {state.item.ChecklistText && state.item.ChecklistText !== "" && <Button variant="primary" onClick={() => this.updateBaseChecklist(state.item)}>Save</Button>}
                        </div>
                    </Modal.Footer>
                </Modal>}
                {!state.confirmDiscard && state.confirmDelete && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="BaseChecklistModalDeleteItemHeader">
                            Are you sure you want to delete this item?
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="BaseChecklistModalDeleteItemFooter">
                            <Button variant="secondary" onClick={() => this.manageState([{ key: "confirmDelete" }, { key: "item", value: null }])}>Back</Button>
                            <Button variant="danger" onClick={() => this.updateBaseChecklist(state.item)}>Delete</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="BaseChecklistModalConfirmDiscardHeader">
                            <p>Discard changes?</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="BaseChecklistModalConfirmDiscardFooter">
                            <Button onClick={() => this.manageState([{ key: "confirmDiscard" }])} variant="secondary">Back</Button>
                            <Button onClick={() => this.confirmDiscard()} variant="danger">Discard</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

export default BaseChecklistConfig